__turbopack_context__.v({
  "contentWrapper": "mCG_OW_contentWrapper",
  "footerContainer": "mCG_OW_footerContainer",
  "leftSide": "mCG_OW_leftSide",
  "logoWrap": "mCG_OW_logoWrap",
  "mainBox": "mCG_OW_mainBox",
  "rightSide": "mCG_OW_rightSide",
  "sectionHeader": "mCG_OW_sectionHeader",
  "styledLinks": "mCG_OW_styledLinks",
});
